import axios from "axios";
import React, { useEffect, useState } from "react";
import MainRouter from "./pages/Router";
import BarterGptLandingPage from "./BarterGptLandingPage";
import BXILogo from "./assets/image 3.png";
import { useGetLoggedInUser } from "./pages/OrderDetailsPage/OrdersInvoicesHooks";

// axios.defaults.baseURL = "http://localhost:7000/";
// axios.defaults.baseURL = "https://bxiback-gp3.unada.in/";

axios.defaults.baseURL = "https://production-api.unada.in/";
axios.defaults.withCredentials = true;
axios.defaults.headers.bxiapikey = `Bearer K8sY2jF4pL3rQ1hA9gZ6bX7wC5vU0t`;

const PENDO_API_KEY = "2bf30b9f-e3c1-4925-6c30-e905cee771cd";

const loadPendo = (visitor, account) => {
  if (!PENDO_API_KEY) {
    console.error("Pendo API Key is missing!");
    return;
  }

  if (window.pendo) {
    initializePendo(visitor, account);
    return;
  }

  const script = document.createElement("script");
  script.src = `https://cdn.pendo.io/agent/static/${PENDO_API_KEY}/pendo.js`;
  script.async = true;
  script.onload = () => {
    if (window.pendo && typeof window.pendo.initialize === "function") {
      initializePendo(visitor, account);
    } else {
      console.error("Pendo script did not load properly.");
    }
  };

  document.body.appendChild(script);
};

const initializePendo = (visitor, account) => {
  window.pendo.initialize({
    visitor: {
      id: visitor?._id || "anonymous",
      email: visitor?.email || "",
      firstName: visitor?.companyName || "",
    },
    account: {
      id: account?._id || "unknown",
      industry: account?.companyType || "unknown",
    },
  });
};

const Loader = () => {
  return (
    <div
      className="loader"
      style={{
        width: "100vw",
        height: "100vh",
        background: "white",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
      }}
    >
      <img src={BXILogo} style={{ width: "300px", height: "300px" }} alt="BXI Logo" />
    </div>
  );
};

function App() {
  const [loading, setLoading] = useState(true);
  const { data: userData, isLoading: userLoading } = useGetLoggedInUser();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
    
  }, []);

  useEffect(() => {
    if (userData) {
      loadPendo(
        {
          id: userData?._id || "anonymous",
          email: userData?.email || "",
          firstName: userData?.companyName || "",
        },
        {
          id: userData?._id || "unknown",
          industry: userData?.companyType || "unknown",
        }
      );
    }
  }, [userData]);

  if (window.self !== window.top) {
    window.top.location = window.self.location;
  }

  return (
    <div className="App">
      {loading ? (
        <Loader />
      ) : (
        <>
          <MainRouter />
          <BarterGptLandingPage />
        </>
      )}
    </div>
  );
}

export default App;
